<h1 matDialogTitle>
  {{title}}
</h1>

<mat-dialog-content>
  <p>
    {{confirmMessage}}
  </p>
</mat-dialog-content>

<ng-container *ngIf="mode === 'CANCEL-SCT-HEADER' || mode === 'CANCEL-SCT-HEADER-INT'">
  <form class="dynamic-form" [formGroup]="cancelForm" style="width: 100%">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Cancel Reason</mat-label>
        <mat-select formControlName="cancelReasonCode">
          <mat-option *ngFor="let cancelReasonCode of cancelReasonCodes" [value]="cancelReasonCode.reasonCode">
            {{cancelReasonCode.description}}
          </mat-option>
        </mat-select>
      </mat-form-field>

    </div>
  </form>
</ng-container>

<mat-dialog-actions>
  <button mat-button matDialogClose>{{declineActionButtonText}}</button>
  <button mat-button (click)="action()">{{acceptActionButtonText}}</button>
</mat-dialog-actions>
